export const ProfTestInterTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: ["OICC"].includes(this.activity) ? "DESCRIPCIÓN DEL ENSAYO/CALIBRACIÓN"
                        : ["OEAP"].includes(this.activity) ? 'DESCRIPCIÓN DEL PROGRAMA'
                            : '',
                    type: 'text',
                    key: 'description',

                },
                {
                    title: "Nº PARTICIPANTES ACREDITADOS",
                    type: 'text',
                    key: 'participants_no',

                },
                ["OICC"].includes(this.activity) ? {
                    title: "ORGANIZADOR",
                    type: 'text',
                    key: 'organizer',

                } : {},
                {
                    title: "FECHAS (PERIODICIDAD)",
                    type: 'text',
                    key: 'periodicity_date',
                },
                ["OICC"].includes(this.activity) ? {
                    title: "RESULTADOS Z-SCORE O FECHA TENTATIVA",
                    type: 'text',
                    key: 'result',

                } : {},
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}